export const SET_CURRENT_CITIES = 'SET_CURRENT_CITIES';

export const actionSetCurrentCities = cities => ({
    type: SET_CURRENT_CITIES,
    payload: cities
})
